import './App.css';
import {
  BrowserRouter as Router,
  Route,
  Routes
} from 'react-router-dom'
import Home from './components/school/Home';

function App() {
  return (
    <>
     <Router>
        <Routes>
          <Route path='/' element={<>HELLO</>} />
          <Route path='/school' element={<Home/>} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
